module.exports = __webpack_public_path__ + "static/media/recortes_home_05.afa73b84.jpg";